import { zChargingStationModelCommonSchema } from "./chargingStationModel.common";
// ChargingStationModel DTO схема (расширяет базовую схему)
export const zChargingStationModelSchemaDto = zChargingStationModelCommonSchema;
export const zChargingStationModelSchemaCreateDto = zChargingStationModelSchemaDto.omit({
    id: true,
});
